var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"device-bg-main"}},[_c('app-user-login-page')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }